export default {
  PRODUCTION: 'PRODUCTION',
  CONSUMPTION: 'CONSUMPTION',
};
